import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=a584f0ec&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a584f0ec')) {
      api.createRecord('a584f0ec', component.options)
    } else {
      api.reload('a584f0ec', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=a584f0ec&", function () {
      api.rerender('a584f0ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LrfuiVgLEUZK/JS/comp/ErrorMessage.vue"
export default component.exports